/*
 * Copyright ish group pty ltd. All rights reserved. https://www.ish.com.au
 * No copying or use of this code is allowed without permission in writing from ish.
 */

import { ofType, StateObservable } from 'redux-observable';
import { catchError, from, map, mergeMap, debounceTime } from 'rxjs';
import { mapError } from 'src/js/common/epics/EpicUtils';
import { BuildContactNodes } from 'src/js/enrol/services/CheckoutService';
import { IAction } from '../../actions/IshAction';
import { IshState } from '../../services/IshState';
import { rewriteContactNodesToState, SYNC_FIELD_VALUES } from '../containers/summary/actions/Actions';


// Make sure inactive voucher forms get cleared
function createEpicRefreshRedeemVouchers() {
  return (action$, store: StateObservable<IshState>) => action$.pipe(
    ofType(SYNC_FIELD_VALUES),
    debounceTime(500),
    mergeMap((action: IAction)  => from(BuildContactNodes.fromState(store.value.checkout.summary, store.value)).pipe(
      map(payload => rewriteContactNodesToState(payload)),
      catchError(mapError(action.type))
    ))
  );
}

export default createEpicRefreshRedeemVouchers();